import React, { useState } from "react";
import ServiceTimeBased from "../../../assets/icons/ServiceTimeBased";
import ServiceTimeBasedHover from "../../../assets/icons/ServiceTimeBasedHover";
import ServiceSessionBasedHover from "../../../assets/icons/ServiceSessionBasedHover";
import ServiceSessionBased from "../../../assets/icons/ServiceSessionBased";
import TooltipDropdown from "../../common/tooltipDropdown"; // Import the TooltipDropdown component
import { ServiceTypes } from "../../../@types/invoice";

interface ServiceTypeProps {
  serviceType: string;
  setServiceType: React.Dispatch<React.SetStateAction<ServiceTypes>>;
  handleServiceTypeChange?: (type: string) => void;
}

const ServiceType = ({
  serviceType,
  setServiceType,
  handleServiceTypeChange,
}: ServiceTypeProps) => {
  const [isHoveredRetail, setIsHoveredRetail] = useState(false);
  const [isHoveredService, setIsHoveredService] = useState(false);
  const [isTooltipHovered1, setIsTooltipHovered1] = useState(false);
  const [isTooltipHovered2, setIsTooltipHovered2] = useState(false);

  const handleOptionClick = (type: string) => {
    setServiceType(type as ServiceTypes);
    handleServiceTypeChange?.(type);
  };

  return (
    <div id="select-service-type" className="fellix max-w-72">
      <h3 className="text-[14px] lg:text-[16px] text-gray-800 font-medium leading-6 flex items-center">
        Select a Template
        <p className="leading-5 text-[#F04438] mt-2 pl-1">*</p>
      </h3>
      <div className="flex gap-8 mt-4 ">
        {/* Time-based option */}
        <div className="w-full">
          <div
            className="cursor-pointer"
            onClick={() => handleOptionClick("time-based")}
            onMouseEnter={() => setIsHoveredRetail(true)}
            onMouseLeave={() => setIsHoveredRetail(false)}
          >
            {serviceType == "time-based" || isHoveredRetail ? (
              <ServiceSessionBasedHover />
            ) : (
              <ServiceSessionBased />
            )}
          </div>
          <div className="relative flex items-center gap-[14px] py-[2.5px] mt-2 w-full justify-center">
            <p className="text-[#828282] font-medium leading-8 text-[14px]">
              Time-based
            </p>
            <div
              onMouseEnter={() => setIsTooltipHovered1(true)}
              onMouseLeave={() => setIsTooltipHovered1(false)}
            >
              <TooltipDropdown
                toolTipText="I sells products directly to consumers through physical stores or online platforms."
                isHovered={isTooltipHovered1}
              />
            </div>
          </div>
        </div>

        {/* Per Session option */}
        <div className="w-full">
          <div
            className="cursor-pointer"
            onClick={() => handleOptionClick("session-based")}
            onMouseEnter={() => setIsHoveredService(true)}
            onMouseLeave={() => setIsHoveredService(false)}
          >
            {serviceType == "session-based" || isHoveredService ? (
              <ServiceTimeBasedHover />
            ) : (
              <ServiceTimeBased />
            )}
          </div>
          <div className="relative flex items-center gap-[14px] py-[2.5px] mt-2 w-full justify-center">
            <p className="text-[#828282] font-medium leading-8 text-[14px]">
              Per Session
            </p>
            <div
              onMouseEnter={() => setIsTooltipHovered2(true)}
              onMouseLeave={() => setIsTooltipHovered2(false)}
            >
              <TooltipDropdown
                toolTipText="I offer services to clients, such as consulting, cleaning, or freelancing."
                isHovered={isTooltipHovered2}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceType;
